export class Exports {
  entityMessage() {
    return `L'export ${this.nom}`;
  }

  constructor({ id = null, nom = null, type = null, application = null } = {}) {
    this.id = id;
    this.nom = nom;
    this.type = type;
    this.application = application ? application : {};
  }
}
